import { adaptItem } from "datasets/pages/tables/hooks/useDatasetTables";
import DatasetTableResponse from "datasets/pages/tables/types/interfaces/table";
import { useFetcher } from "~/hooks/useFetcher";
import { V1TableListEnvelope, V1TableResult } from "~/types/interfaces/catalogTables";

const { VITE_CATALOG_API } = import.meta.env;

type PersonalDatasetTablesResponse = V1TableListEnvelope<V1TableResult>;

// GET /v1/users/me/dataset/tables shares the items/metadata envelope of the
// dataset-scoped v1 table listing, so it reuses that endpoint's item adapter.
export const usePersonalDatasetTables = () => {
  const resp = useFetcher<PersonalDatasetTablesResponse>(
    `${VITE_CATALOG_API}/v1/users/me/dataset/tables`
  );

  return {
    ...resp,
    data: resp.data ? resp.data.items.map(adaptItem) : undefined,
  } as typeof resp & { data: DatasetTableResponse[] | undefined };
};

export default usePersonalDatasetTables;
